<template>
  <v-form ref="form" @submit="Confirm" lazy-validation>
    <v-card class="elevation-12">
      <v-card-title primary-title class="primary">
        <div class="headline white--text">Set New Password</div>
      </v-card-title>
      <v-card-text>
        <v-text-field
          autocomplete="username"
          prepend-icon="person"
          name="username"
          label="Username"
          :rules="nameRules"
          :disabled="loading"
          v-model="user.username"
          type="text">
        </v-text-field>
        <v-text-field
          autocomplete="old-password"
          id="oldPassword"
          prepend-icon="lock"
          name="oldPassword"
          label="Old Password"
          :rules="passwordRules"
          :disabled="loading"
          v-model="user.oldPassword"
          type="password">
        </v-text-field>
        <v-text-field
          autocomplete="new-password"
          id="newPassword"
          prepend-icon="lock"
          name="newPassword"
          label="New Password"
          :rules="passwordRules"
          :disabled="loading"
          v-model="user.newPassword"
          type="password">
        </v-text-field>
        <router-link to="SignIn">Login</router-link>&nbsp;
        <router-link to="ForgotPassword">Forgot Password</router-link>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="Confirm"
          :loading="loading"
          type="submit">
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'ConfirmSignUp',
    data() {
      return {
        loading: false,
        nameRules: [
          (v) => !!v || 'Username ist ein Pflichtfeld',
          (v) => (v && v.length <= 10) || 'Username must be less than 10 characters',
        ],
        passwordRules: [
          (v) => !!v || 'Passwort ist ein Pflichtfeld',
        ],
        user: {
          username: null,
          oldPassword: null,
          newPassword: null,
        },
      };
    },
    computed: {
      ...mapGetters({
        username: 'auth/username',
        oldPassword: 'auth/oldPassword',
      }),
    },
    methods: {
      ...mapActions({
        completeNewPassword: 'auth/completeNewPassword',
        showSnackbar: 'snackbar/success',
      }),
      Confirm(e) {
        e.preventDefault();
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.completeNewPassword(this.user)
            .then((res) => {
              this.loading = false;
              if (res) {
                this.showSnackbar('New Password set, you can log in now');
                this.$router.push({ name: 'SignIn' });
              }
            });
        }
      },
    },
    mounted() {
      if (this.username) {
        this.user.username = this.username;
      }
      if (this.oldPassword) {
        this.user.oldPassword = this.oldPassword;
      }
    },
  };
</script>

<style scoped>

</style>
